import { Icon } from './Icon'
import type { IconProps } from './Icon'
export const LoaderIcon = (p: IconProps) => <Icon {...p} className={`${p.className || ''} spin`}><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" /></Icon>
